import { render } from "./GuideCapture.vue?vue&type=template&id=3dea6de9&scoped=true"
import script from "./GuideCapture.vue?vue&type=script&lang=js"
export * from "./GuideCapture.vue?vue&type=script&lang=js"

import "./GuideCapture.vue?vue&type=style&index=0&id=3dea6de9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dea6de9"]])

export default __exports__